import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidenavComponent } from './layout/sidenav/sidenav.component';
import { CommonModule } from '@angular/common';
import { AppService } from './services/app.service';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { ProfileSettingsComponent } from './components/profile-settings/profile-settings.component';
import { ModalComponent } from './components/modal/modal.component';
import { LoaderComponent } from './components/loader/loader.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    SidenavComponent,
    CommonModule,
    NotificationsComponent,
    ProfileSettingsComponent,
    ModalComponent,
    LoaderComponent
  ],
  templateUrl: './app.component.html'
})
export class AppComponent {
  private readonly _service = inject(AppService);
  readonly isLoggedIn = this._service.isUserLoggedIn;
  readonly sidenav = this._service.sideNav;
  readonly facebookConnected = this._service.facebookConnected;
  readonly logoutLoader = this._service.logoutLoader;
  logout() { this._service.logout() };
  closeLogoutModal() { this._service.closeLogoutModal() };
  handleFBLogout(event: Event) { this._service.handleFbLogout(event) }
}
